/**
 * Platform detection utilities
 */

/**
 * Determines if the current platform is Mac
 * Uses modern userAgentData API with fallback to navigator.platform
 * @returns {boolean} true if running on Mac, false otherwise
 */
export function isMac() {
  const os = navigator.userAgentData?.platform || navigator.platform
  return /mac/i.test(os)
}
